import { isSolutionsPreviewPath } from './solutionsPreview'

const LANDING_PATHS = ['/', '/landing', '/otslezhivanie-bez-gps']

export function isStoryLanding(pathname: string) {
  return LANDING_PATHS.includes(pathname) || isSolutionsPreviewPath(pathname)
}

export function getLandingReturnTo(state: unknown): string | null {
  if (!state || typeof state !== 'object' || !('landingReturnTo' in state)) return null
  const target = state.landingReturnTo
  if (typeof target !== 'string') return null
  // Keep the allowlist local and reject protocol-relative/external return URLs.
  if (!isStoryLanding(target.split(/[?#]/, 1)[0])) return null
  return target
}
